import * as React from "react";
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";
import "./CardTitle.scss";

class CardTitle extends React.PureComponent<any> {
  render() {
    const { title, children } = this.props;
    return (
      <Row className={"card-title flex-column-reverse flex-sm-row mb-0"}>
        <Col className={"d-flex align-items-center"} sm={8} xs={12}>
          <div className={"w-100"}>
              <a href={window.location.origin}>
                  <h1 className={"mb-3 text-center text-nowrap text-sm-left"}>{title}</h1>
              </a>
          {children && children}</div>
        </Col>
        <Col className={"d-flex justify-content-center justify-content-sm-end logo-wrapper"} sm={4} xs={12}>
            <a href={window.location.origin}>
                <div className="logo mb-3" />
            </a>
        </Col>
      </Row>
    );
  }
}

export default connect()(CardTitle);
